module.exports = __webpack_public_path__ + "img/assNoti.a06e83e4.svg";